import {Button, Input, Modal, notification, Select, Typography} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Dragable, {DraggableData, DraggableEvent} from "react-draggable";
import '../ModalStyles.scss';
import {UserModel} from "../../models/UserModel";
import {FilialModel} from "../../models/FilialModel";
import {filialAPI} from "../../services/FilialService";
import {FilialGridModel} from "../../models/FilialGridModel";
import {EquipmentModel} from "../../models/EquipmentModel";
import {objectAPI} from "../../services/ObjectService";
import {equipmentAPI} from "../../services/EquipmentService";
import {ObjectModel} from "../../models/ObjectModel";

const {Text} = Typography;

type ModalProps = {
    infoNotification: Function,
    errorNotification: Function,
    object: ObjectModel,
    setVisible: Function,
    getObjects: Function,
}

export const UpdateObjectModal = (props: ModalProps) => {
    const [updateObject, {
        error: errorUpdateObject,
        isSuccess: isSuccessUpdateObject,
        isError: isErrorUpdateObject
    }] = objectAPI.useUpdateObjectMutation();
    const [getFilialsRequest, {
        data: dataGetFilialsRequest,
        isLoading: isGettingFilialsInProcess,
    }] = filialAPI.useGetFilialsMutation();
    const [deleteObject, {
        isSuccess: isSuccessDeleteObject,
        isError: isErrorDeleteObject,
        error: errorDeleteObject
    }] = objectAPI.useDeleteObjectMutation();

    // Draggable settings
    const [disabled, setDisabled] = useState<boolean>(false);
    const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggableRef = useRef<HTMLDivElement>(null);
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggableRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top - uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        })
    }
    // End of dnd
    const [modalWidth,] = useState<number>(500);
    const [name, setName] = useState<string>(props.object.name);
    const [selectedFilial, setSelectedFilial] = useState<string>(props.object.filial.code);
    useEffect(() => {
        getFilialsRequest()
    }, []);
    useEffect(() => {
        if (isSuccessUpdateObject || isSuccessDeleteObject) {
            props.getObjects()
            props.setVisible(false)
        }
        if (isSuccessDeleteObject) props.infoNotification("Объект удален")
        if (isSuccessUpdateObject) props.infoNotification("Объект обновлен")
    }, [isSuccessUpdateObject, isSuccessDeleteObject]);
    useEffect(() => {
        if (isErrorUpdateObject && errorUpdateObject) {
            if (errorUpdateObject.toString() === '400')
                props.errorNotification("Наименование должно быть уникальным")
            else
                props.errorNotification(JSON.stringify(errorUpdateObject))
        }
    }, [isErrorUpdateObject]);
    useEffect(() => {
        if (isErrorDeleteObject && errorDeleteObject) {
            if (errorDeleteObject.toString() === '400')
                props.errorNotification("На объект ссылаются другие сущности")
            else
                props.errorNotification(JSON.stringify(errorDeleteObject))
        }
    }, [isErrorDeleteObject])
    const handleUpdateObject = () => {
        console.log(props.object.equipments)
        if (name && dataGetFilialsRequest) {
            const filial: FilialModel | undefined = dataGetFilialsRequest.find((filial: FilialModel) => filial.code === selectedFilial);
            if (filial) {
                const obj: ObjectModel = {
                    id: props.object.id,
                    name,
                    filial,
                    equipments: props.object.equipments,
                }
                updateObject(obj);
            }
        }
    }
    const handleDeleteObject = () => {
        if (props.object.id) deleteObject(props.object.id);
    }
    return (
        <Modal
            title={'Редактирование объекта'}
            centered={true}
            open={true}
            footer={[]}
            modalRender={(modal) => (
                // @ts-ignore
                <Dragable
                    disabled={disabled}
                    bounds={bounds}
                    onStart={(event, uiData) => onStart(event, uiData)}
                >
                    <div ref={draggableRef}>{modal}</div>
                </Dragable>
            )}
            width={modalWidth}
            onCancel={() => props.setVisible(false)}
        >
            <div className="modalFlex">
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Наименование</Text>
                    <Input value={name} onChange={(e: any) => setName(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Филиал</Text>
                    <Select
                        value={selectedFilial}
                        onChange={setSelectedFilial}
                        style={{width: '100%'}}
                        options={dataGetFilialsRequest ? dataGetFilialsRequest.map((item: FilialModel) => ({
                            value: item.code,
                            label: item.name,
                        })) : []}
                    />
                </div>

                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalButtons">
                    <Button onClick={handleUpdateObject}>Сохранить</Button>
                    <Button onClick={() => props.setVisible(false)}>Отменить</Button>
                    <Button danger onClick={handleDeleteObject}>Удалить</Button>
                </div>
            </div>
        </Modal>
    )
}